import request from '@/assets/request.js'

// 二.商品单位
export function saveGoodsUnit(param = {}, resParams) { //添加商品单位
  return request.post('qrcapi/GoodsUnit_saveGoodsUnit', param, resParams)
}
export function goodsUnitList(param = {}, resParams) { //商品单位列表
  return request.post('qrcapi/GoodsUnit_goodsUnitList', param, resParams)
}
export function listTotalNum(param = {}, resParams) { //列表总记录数和条件
  return request.post('qrcapi/GoodsUnit_listTotalNum', param, resParams)
}
export function batchUpdateUnit(param = {}, resParams) { //批量操作单位 排序、删除、启\禁用
  return request.post('qrcapi/GoodsUnit_batchUpdateUnit', param, resParams)
}

//进销存
//六.供应商
export function supplierList(param = {}, resParams) { //供应商列表
  return request.post('/qrcapi/Supplier_supplierList', param, resParams)
}
export function supplierListTotal(param = {}, resParams) { //供应商列表页数
  return request.post('/qrcapi/Supplier_listTotalNum', param, resParams)
}
export function saveSupplierClassification(param = {}, resParams) { //添加分类
  return request.post('/qrcapi/Supplier_saveSupplierClassification', param, resParams)
}
export function modifySupplierClassification(param = {}, resParams) { //更新分类
  return request.post('/qrcapi/Supplier_modifySupplierClassification', param, resParams)
}
export function deleteSupplierClassification(param = {}, resParams) { //删除分类
  return request.post('/qrcapi/Supplier_deleteSupplierClassification', param, resParams)
}
export function supplierClassificationList(param = {}, resParams) { //供应商分类列表
  return request.post('/qrcapi/Supplier_supplierClassificationList', param, resParams)
}
export function supplierClassificationListTotal(param = {}, resParams) { //供应商分类列表页数
  return request.post('/qrcapi/SupplierCategory_listTotalNum', param, resParams)
}
export function saveSupplier(param = {}, resParams) { //添加新的供应商
  return request.post('/qrcapi/Supplier_saveSupplier', param, resParams)
}
export function modifySupplier(param = {}, resParams) { //修改供应商
  return request.post('/qrcapi/Supplier_modifySupplier', param, resParams)
}
export function refundGoodsListTotalNum(param = {}, resParams) { //进货退货单列表总数
  return request.post('/qrcapi/RefundGoods_listTotalNum', param, resParams)
}
export function refundGoodsList(param = {}, resParams) { //进货退货单列表
  return request.post('/qrcapi/RefundGoods_refundGoodsList', param, resParams)
}
export function repositoryList(param = {}, resParams) { //仓库列表
  return request.post('/qrcapi/Repository_repositoryList', param, resParams)
}
export function Shop_handlerList(param = {}, resParams) { //经手人列表
  return request.post('/qrcapi/Shop_handlerList', param, resParams)
}
export function getRefundGoodsStatistic(param = {}, resParams) { //获取退款总金额
  return request.post('/qrcapi/RefundGoods_getRefundGoodsStatistic', param, resParams)
}
export function goodsPurchaseList(param = {}, resParams) { //进货列表
  return request.post('/qrcapi/PurchaseGoods_goodsPurchaseList', param, resParams)
}
export function goodsPurchaseListTotalNum(param = {}, resParams) { //进货列表总条数
  return request.post('/qrcapi/PurchaseGoods_listTotalNum', param, resParams)
}
export function goodslistTotalNumundGoods(param = {}, resParams) { //商品列表分页
  return request.post('/qrcapi/RepositoryGoodsDetail_goodslistTotalNum', param, resParams)
}
export function repositoryGoodsDetailList(param = {}, resParams) { //商品列表
  return request.post('/qrcapi/RepositoryGoodsDetail_repositoryGoodsDetailList', param, resParams)
}
export function createOrUpdateGoods(param = {}, resParams) { //添加\更新商品分类列表
  return request.post('/qrcapi/Goods_createOrUpdateGoods', param, resParams)
}
export function goodsCategoryLists(param = {}, resParams) { //分类列表
  return request.post('/qrcapi/GoodsCategory_goodsCategoryList', param, resParams)
}
export function defaultParam(param = {}, resParams) { //默认参数
  return request.post('/qrcapi/Repository_defaultParam', param, resParams)
}
export function saveRefundGoods(param = {}, resParams) { //确认结算
  return request.post('/qrcapi/RefundGoods_saveRefundGoods', param, resParams)
}
export function saveGoodsPurchase(param = {}, resParams) { //进货单创建
  return request.post('/qrcapi/PurchaseGoods_saveGoodsPurchase', param, resParams)
}
export function repositoryGoodsQueryList(param = {}, resParams) { //库存查询列表
  return request.post('/qrcapi/RepositoryGoodsDetail_repositoryGoodsQueryList', param, resParams)
}
export function repositoryGoodsQuerylistTotalNum(param = {}, resParams) { //库存查询列表总记录数和条件
  return request.post('/qrcapi/RepositoryGoodsDetail_listTotalNum', param, resParams)	
}
export function getRepositoryTotalStatistic(param = {}, resParams) { //可用库存，库存总额合计
  return request.post('/qrcapi/RepositoryGoodsDetail_getRepositoryTotalStatistic', param, resParams)
}
export function singleQueryGoods(param = {}, resParams) { //单个商品的库存查询
  return request.post('/qrcapi/RepositoryGoodsDetail_singleQueryGoods', param, resParams)
}
export function repositoryFlowList(param = {}, resParams) { //库存流水列表
  return request.post('/qrcapi/RepositoryFlow_repositoryFlowList', param, resParams)
}
export function repositoryFlowListTotalNum(param = {}, resParams) { //库存流水列表总记录数和条件
  return request.post('/qrcapi/RepositoryFlow_listTotalNum', param, resParams)
}
export function singleReturnGoodsList(param = {}, resParams) { //退货进货单详情  
  return request.post('/qrcapi/RefundGoods_singleRefundGoodsAll', param, resParams)
}
export function destroyRefundGoods(param = {}, resParams) { //作废退货进货单 
  return request.post('/qrcapi/RefundGoods_destroyRefundGoods', param, resParams)
}
export function singlePurchaseAll(param = {}, resParams) { //关联进货单详情
  return request.post('/qrcapi/PurchaseGoods_singlePurchaseAll', param, resParams)
}
export function updateTakePrice(param = {}, resParams) { //更新拿货价
  return request.post('/qrcapi/Goods_updateTakePrice', param, resParams)
}
export function singleGoodsPurchase(param = {}, resParams) { //查看单个进货单列表
  return request.post('/qrcapi/PurchaseGoods_singlePurchaseAll', param, resParams)
}
export function destroygoodsPurchase(param = {}, resParams) { //作废进货单
  return request.post('/qrcapi/PurchaseGoods_destroygoodsPurchase', param, resParams)
}
export function enterGoodsPurchaseNotAll(param = {}, resParams) { //部分商品入库
  return request.post('/qrcapi/PurchaseGoods_enterGoodsPurchaseNotAll', param, resParams)
}
export function singleGoodsCheckAll(param = {}, resParams) { //单个盘点单详情
  return request.post('/qrcapi/GoodsCheck_singleGoodsCheckAll', param, resParams)
}
export function destroyGoodsCheck(param = {}, resParams) { //作废盘点单
  return request.post('/qrcapi/GoodsCheck_destroyGoodsCheck', param, resParams)	
}
export function singleGoodsChangeAll(param = {}, resParams) { //单个调拨单详情
  return request.post('/qrcapi/GoodsChange_singleGoodsChangeAll', param, resParams)
}
export function destroyChangeGoods(param = {}, resParams) { //单个调拨单详情
  return request.post('/qrcapi/GoodsChange_destroyChangeGoods', param, resParams)
}
export function goodsCheckList(param = {}, resParams) { //盘点单列表
  return request.post('/qrcapi/GoodsCheck_goodsCheckList', param, resParams)
}
export function lockRepository(param = {}, resParams) { //是否锁定仓库
  return request.post('/qrcapi/Repository_lockRepository', param, resParams)
}
export function enterGoodsChangeNotAll(param = {}, resParams) { //单个调拨单详情
  return request.post('/qrcapi/GoodsChange_enterGoodsChangeNotAll', param, resParams)
}
export function modifyOrSaveGoodsCheck(param = {}, resParams) { //保存盘点单
  return request.post('/qrcapi/GoodsCheck_modifyOrSaveGoodsCheck', param, resParams)
}
export function GoodsCheckListTotalNum(param = {}, resParams) { //盘点单列表总记录数和条件
  return request.post('/qrcapi/GoodsCheck_listTotalNum', param, resParams)
}
export function goodsChangeList(param = {}, resParams) { //调拨单列表
  return request.post('/qrcapi/GoodsChange_goodsChangeList', param, resParams)
}
export function saveGoodsChange(param = {}, resParams) { //新增调拨单
  return request.post('/qrcapi/GoodsChange_saveGoodsChange', param, resParams)
}
export function goodsChangeListTotalNum(param = {}, resParams) { //调拨单列表总记录数和条件
  return request.post('/qrcapi/GoodsChange_listTotalNum', param, resParams)
}
export function checkCJGoodsChange(param = {}, resParams) { //调拨单审核
  return request.post('/qrcapi/GoodsChange_checkCJGoodsChange', param, resParams)
}
export function checkDesChangeGoods(param = {}, resParams) { //作废后审核完成，重置商品数量
  return request.post('/qrcapi/GoodsChange_checkDesChangeGoods', param, resParams)
}
export function getNewstInfo(param = {}, resParams) { //调拨单审核
  return request.post('/qrcapi/Repository_getNewstInfo', param, resParams)
}
// 收银开单退货退款
export function findRefundGoodsList(param = {}, resParams) { //退款商品列表
  return request.post('/qrcapi/MallOrder_findRefundGoodsList', param, resParams)
}
export function refundGoodsTotalNum(param = {}, resParams) { //退款商品列表总记录数
  return request.post('/qrcapi/MallOrder_refundGoodsTotalNum', param, resParams)
}
export function getRefundStatistic(param = {}, resParams) { //退货订单数，退货总金额  
  return request.post('/qrcapi/MallOrder_getRefundStatistic', param, resParams)
}
export function refundMallOrderDetail(param = {}, resParams) { //订单退款详情  
  return request.post('/qrcapi/MallOrder_refundMallOrderDetail', param, resParams)
}
export function findRefundOrderList(param = {}, resParams) { // 退款订单列表  
  return request.post('/qrcapi/MallOrder_findRefundOrderList', param, resParams)
}
export function refundOrderTotalNum(param = {}, resParams) { // 退款订单列表总记录  
  return request.post('/qrcapi/MallOrder_refundOrderTotalNum', param, resParams)
}
export function toRefundOrderDetail(param = {}, resParams) { // 退货订单详情  
  return request.post('/qrcapi/MallOrder_toRefundOrderDetail', param, resParams)
}
export function saveMallOrderRefund(param = {}, resParams) { //创建销售退款单  
  return request.post('/qrcapi/RefundGoods_saveMallOrderRefund', param, resParams)
}
export function enterRefundGoods(param = {}, resParams) { //销售退款商品入库  
  return request.post('/qrcapi/RefundGoods_enterRefundGoods', param, resParams)
}
export function refundSelectProductList(param = {}, resParams) { //退货订单详情  
  return request.post('/qrcapi/MallOrder_refundSelectProductList', param, resParams)
}
//收银开单 订单接口

export function preOrder(param = {}, resParams) { // 会员买单(收银开单)
  return request.post('/qrcapi/MallOrder_preOrder', param, resParams)
}
export function payByShopMemberCard(param = {}, resParams) { // 使用会员卡买单
  return request.post('/qrcapi/MallOrder_payByShopMemberCard', param, resParams)
}
export function handleOrderForShopWorker(param = {}, resParams) { // 现金收款 、标记收款
  return request.post('/qrcapi/MallOrder_handleOrderForShopWorker', param, resParams)
}
export function userPayScan(param = {}, resParams) { //扫码支付
  return request.post('/qrcapi/Pay_userPayScan', param, resParams)
}
export function mallOrders(param = {}, resParams) { // 订单列表
  return request.post('/qrcapi/MallOrder_mallOrders', param, resParams)
}
export function toOrderDetail(param = {}, resParams) { // 订单详情
  return request.post('/qrcapi/MallOrder_toOrderDetail', param, resParams)
}
export function Order_payResult(param = {}, resParams) { // 订单轮询
  return request.post('/qrcapi/Order_payResult', param, resParams)
}
//钱如潮
export function getBindWxQrValue(param = {}, resParams) { //新版添加会员
  return request.post('/qrcapi/ShopMember_getBindWxQrValue', param, resParams)
}
export function payTypeAmount(param = {}, resParams) { //各支付方式金额
  return request.post('/qrcapi/ChangeShifts_payTypeAmount', param, resParams)
}
 
export function shopMemberRecharge(param = {}, resParams) { //会员充值 下单 1 现金收款 2扫码收款
  return request.post('/qrcapi/ShopMember_shopMemberRecharge', param, resParams)
}
export function activityList(param = {}, resParams) { //查询活动列表
  return request.post('/qrcapi/ShopMemberActivity_shopMemberActivityList', param, resParams)
}
export function deleteCashCouponBatch(param = {}, resParams) { //删除优惠券
  return request.post('/qrcapi/CashCoupon_deleteCashCouponBatch', param, resParams)
}
export function findUserCashCoupons(param = {}, resParams) { //查找某用户在本店的优惠券
  return request.post('/qrcapi/CashCoupon_findUserCashCoupons', param, resParams)
}
export function shopMemberList(param = {}, resParams) { //店铺会员列表
  return request.post('/qrcapi/ShopMember_shopMemberList', param, resParams)
}
export function workingStatus(param = {}, resParams) { //交接班上班状态
  return request.post('/qrcapi/ChangeShifts_workingStatus', param, resParams)
}
export function goToWork(param = {}, resParams) { //交接班上班
  return request.post('/qrcapi/ChangeShifts_goToWork', param, resParams)
}
export function goOffWork(param = {}, resParams) { //交接班下班
  return request.post('/qrcapi/ChangeShifts_goOffWork', param, resParams)
}
export function workingInfo(param = {}, resParams) { //交接班当前员工的上班信息
  return request.post('/qrcapi/ChangeShifts_workingInfo', param, resParams)
}
export function writeOffListTotalNum(param = {}, resParams) { //核销抵用券列表列表总记录数和条件
  return request.post('/qrcapi/CashCoupon_writeOffListTotalNum', param, resParams)
}
export function writeOffCashCouponList(param = {}, resParams) { //核销抵用券列表
  return request.post('/qrcapi/CashCoupon_writeOffCashCouponList', param, resParams)
}
export function getCardDetail(param = {}, resParams) { //查看卡券详情
  return request.post('/qrcapi/CashCoupon_getCardDetail', param, resParams)
}
export function saleStatisticsList(param = {}, resParams) { //销售员销售统计list
  return request.post('/qrcapi/MallOrder_saleStatisticsList', param, resParams)
}
export function saleListTotalNum(param = {}, resParams) { //销售员统计list总记录数和条件
  return request.post('/qrcapi/MallOrder_saleListTotalNum', param, resParams)
}
export function cashierStatisticsList(param = {}, resParams) { //收银员销售统计list
  return request.post('/qrcapi/MallOrder_cashierStatisticsList', param, resParams)
}
export function cashierListTotalNum(param = {}, resParams) { //收银员统计list总记录数和条件
  return request.post('/qrcapi/MallOrder_cashierListTotalNum', param, resParams)
}
export function shopWorkersForType(param = {}, resParams) { //员工列表
  return request.post('/qrcapi/Shop_shopWorkersForType', param, resParams)
}
export function findApplyPay(param = {}, resParams) { //商户支付信息查看
  return request.post('/qrcapi/Shop_findApplyPay', param, resParams)
}
export function goodsCategoryPager(param = {}, resParams) { //商品分类列表
  return request.post('/qrcapi/GoodsCategory_goodsCategoryPager', param, resParams)
}
export function workerInfo(param = {}, resParams) { //获取店员，店主的个人信息
  return request.post('/qrcapi/Shop_workerInfo', param, resParams)
}
export function Shop_shopWorkers(param = {}, resParams) { //员工列表
  return request.post('/qrcapi/Shop_shopWorkers', param, resParams)
}
export function Shop_shopStores(param = {}, resParams) { //门店列表
  return request.post('/qrcapi/Shop_shopStores', param, resParams)
}
export function shopMemberActivityList(param = {}, resParams) { //会员卡列表
  return request.post('qrcapi/ShopMemberCard_shopMemberCardList', param, resParams)
}
export function printOrder(param = {}, resParams) { //打印订单
  return request.post('/qrcapi/MallOrder_getPrintContentForHtml', param, resParams)
}
export function getPrintContentForPc(param = {}, resParams) { // 商家打印模板html
  return request.post('/qrcapi/MallOrder_getPrintContent', param, resParams)
}
export function shopMemberCardList(param = {}, resParams) {
  return request.post("qrcapi/ShopMemberCard_shopMemberCardList", param, resParams)
}

// 优惠券  
export function getCashCouponList(param = {}, resParams) { // 优惠券列表
  return request.post('/qrcapi/CardCoupon_cashCouponList', param, resParams)
}
export function sendCashCoupon(param = {}, resParams) { // 主动定向发券    
  return request.post('/qrcapi/CashCoupon_sendCashCoupon', param, resParams)
}
export function stopCashCoupon(param = {}, resParams) { // 停用单个券种类    
  return request.post('/qrcapi/CashCoupon_stopCashCoupon', param, resParams)
}
export function getCashCouponUsedDetail(param = {}, resParams) { // 单个券种类使用列表    
  return request.post('/qrcapi/CardCoupon_cashCouponUsedDetail', param, resParams)
}    
export function addPublishCashCoupon(param = {}, resParams) { // 增加优惠券   
  return request.post('/qrcapi/CashCoupon_publishCashCoupon', param, resParams)
}
export function getCashCouponUsedDetailList(param = {}, resParams) { // 营销统计列表
  return request.post('/qrcapi/CardCoupon_cashCouponUsedDetailList', param, resParams)
}
export function removeShopMember(param = {}, resParams) { // 会员删除
  return request.post('/edcmanageapi/ShopMember_removeShopMember', param, resParams)
} 

export function deleteCashCoupon(param = {}, resParams) { // 优惠券删除
  return request.post('/edcmanageapi/CashCoupon_deleteCashCoupon', param, resParams)
}


//  上传
export function uploadImg(param = {}, resParams) { //图片上传地址
    return request.customPost('YmUpload_image', param, resParams, "https://api.yichengshi.cn/")
}
export function uploadExcl(param = {}, resParams) { //文件上传地址
    return request.customPost('qrcapi/Goods_importGoodsNum', param, resParams, "https://api.yichengshi.cn/")
}
export function uploadExcl2(param = {}, resParams) { //文件上传地址
    return request.customPost('qrcapi/Goods_importGoodsCategory', param, resParams, "https://api.yichengshi.cn/")
}
export function toShopMemberTableTags(param = {}, resParams) { //文件上传地址
    return request.customPost('qrcapi/ShopMember_toShopMemberTableTags', param, resParams, "https://api.yichengshi.cn/")
}
//  上传
// export function uploadImg(param = {}, resParams) { //图片上传地址
//   return request.customPost('/ImageServer/YmUpload_image', param, resParams, "http://192.168.1.33:8888")
// }
// export function uploadExcl(param = {}, resParams) { //文件上传地址
//   return request.customPost('qrcapi/Goods_importGoodsNum', param, resParams, "http://192.168.1.103:8084/")
// }
// export function uploadExcl2(param = {}, resParams) { //文件上传地址
//   return request.customPost('qrcapi/Goods_importGoodsCategory', param, resParams, "http://192.168.1.103:8084/")
// }
// export function toShopMemberTableTags(param = {}, resParams) { //文件上传地址
//   return request.customPost('qrcapi/ShopMember_toShopMemberTableTags', param, resParams, "http://192.168.1.103:8084/")
// }


// 登录注册
export function findImageCaptcha(param = {}, resParams) { //图形验证码
  return request.post('/edcmanageapi/ImageCaptca_findImageCaptcha', param, resParams)
}
export function pclogin(param = {}, resParams) { //用户登录
  return request.post('/edcmanageapi/Login_pclogin', param, resParams)
}
export function findPassCaptch(param = {}, resParams) { //忘记密码发送验证码
  return request.post('/edcmanageapi/Login_findPassCaptcha', param, resParams)
}
export function findPassWord(param = {}, resParams) { //忘记密码的情况下修改密码
  return request.post('/edcmanageapi/Login_findPassWord', param, resParams)
}
export function getShopMemberCardList(param = {}, resParams) {
  return request.post('/edcmanageapi/ShopMember_shopMemberCardList', param, resParams)
}

export function getUserFuncProductList(param = {}, resParams) {
  return request.post('/edcmanageapi/UserFunc_findUserFuncProductList', param, resParams)
}
// 商品
export function getEdcShopGoodsCategorys(param = {}, resParams) {
  return request.post('/edcmanageapi/Shop_getEdcShopGoodsCategorys', param, resParams)
}
export function getFindAllGoodsPlus(param = {}, resParams) {
  return request.post('/edcmanageapi/Goods_findAllGoodsPlus', param, resParams)
}

// 积分商城     
export function getOfficialGoodsCategoryList(param = {}, resParams) { // 获取商品分类列表
  return request.post('/qrcapi/OfficialGoodsCategory_officialGoodsCategoryList', param, resParams)
}
export function getGoodsCategoryListTotalNum(param = {}, resParams) { // 获取商品分类列表总记录数
  return request.post('/qrcapi/OfficialGoodsCategory_listTotalNum', param, resParams)
}
export function getOfficialGoodsList(param = {}, resParams) { // 获取商品列表
  return request.post('/qrcapi/OfficialGoods_officialGoodsList', param, resParams)
}
export function getOfficialGoodsListTotalNum(param = {}, resParams) { // 获取商品列表总记录数
  return request.post('/qrcapi/OfficialGoods_listTotalNum', param, resParams)
}
export function modifyOfficialGoodsSaleStatus(param = {}, resParams) { // 商品上下架
  return request.post('/qrcapi/OfficialGoods_modifyOfficialGoodsSaleStatus', param, resParams)
}
export function modifyOrSaveOfficialGoodsCategory(param = {}, resParams) { // 商品分类新增、修改
  return request.post('/qrcapi/OfficialGoodsCategory_modifyOrSaveOfficialGoodsCategory ', param, resParams)
}
export function deleteOfficialGoods(param = {}, resParams) { // 商品删除
  return request.post('/qrcapi/OfficialGoods_deleteOfficialGoods', param, resParams)
} 
export function modifyOfficialGoodsCategory(param = {}, resParams) { // 修改商品所在的分类
  return request.post('/qrcapi/OfficialGoods_modifyOfficialGoodsCategory', param, resParams)
} 
export function modifyOrSaveOfficialGoods(param = {}, resParams) { // 新增/修改商品
  return request.post('/qrcapi/OfficialGoods_modifyOrSaveOfficialGoods', param, resParams)
}
export function getSingleOfficialGoods(param = {}, resParams) { // 商品详情 
  return request.post('/qrcapi/OfficialGoods_singleOfficialGoods', param, resParams)
}
export function deleteOfficialGoodsCategory(param = {}, resParams) { // 商品分类删除
  return request.post('/qrcapi/OfficialGoodsCategory_deleteOfficialGoodsCategory', param, resParams)
}
export function getCardScoreList(param = {}, resParams) {  // 会员积分
  return request.post('/edcmanageapi/CardCoupon_cardScoreList', param, resParams)
}
export function getGasAuthsList(param = {}, resParams) {  // 获取权限列表
  return request.post('/qrcapi/IndustrySolutions_getGasAuths', param, resParams)
} 
export function findGasAuthsByUser(param = {}, resParams) {  // 已选权限列表
  return request.post('/qrcapi/IndustrySolutions_findGasAuthsByUser', param, resParams)
}
export function batchSetGasAuth(param = {}, resParams) {  // 批量设置权限
  return request.post('/qrcapi/IndustrySolutions_batchSetGasAuth', param, resParams)
}
export function rechargeConsumList(param = {}, resParams) { // 会员消费明细
  return request.post( '/edcmanageapi/Member_rechargeConsumList', param, resParams)
}
export function officialMallOrderList(param = {}, resParams) { // 订单列表
  return request.post( '/qrcapi/OfficialMallOrder_officialMallOrderList', param, resParams)
}
export function officialMallOrderListTotalNum(param = {}, resParams) { // 订单列表总记录数
  return request.post( '/qrcapi/OfficialMallOrder_listTotalNum', param, resParams)
}
export function finishMallOrder(param = {}, resParams) { // 完成兑换
  return request.post( '/qrcapi/OfficialMallOrder_finishMallOrder', param, resParams)
}

// 店铺
export function getCashCouponBatchList(param = {}, resParams) { // 获取店铺优惠券列表
  return request.post('/qrcapi/CashCoupon_cashCouponBatchList', param, resParams)
}
export function getShopInfo(param = {}, resParams) {
  return request.post('/edcmanageapi/Shop_getShopInfo', param, resParams)
}
export function getShopCategorys(param = {}, resParams) {
  return request.post('/edcmanageapi/Shop_getEdcShopCategorys', param, resParams)
}
export function getShopAreas(param = {}, resParams) {
  return request.post('/edcmanageapi/Shop_getShopAreas', param, resParams)
}
export function getShopTables(param = {}, resParams) {
  return request.post('/edcmanageapi/Shop_getShopTables_V3', param, resParams)
}
export function getShopNotices(param = {}, resParams) {
  return request.post('/edcmanageapi/Shop_notices', param, resParams)
}
export function getShopNoticeInfo(param = {}, resParams) {
  return request.post('/edcmanageapi/Shop_noticeInfo', param, resParams)
}
export function getShopApplyPayInfo(param = {}, resParams) {
  return request.post('/edcmanageapi/Shop_applyPayInfo', param, resParams)
}
export function setShopIsBusiness(param = {}, resParams) { //修改店铺状态
  return request.post('/edcmanageapi/Shop_setShopIsBusiness', param, resParams)
}
export function toSetIsAutoTake(param = {}, resParams) { //修改自动接单
  return request.post('/edcmanageapi/Shop_toSetIsAutoTake', param, resParams)
}
export function modifyShopInfo(param = {}, resParams) { //修改店铺信息
  return request.post('/edcmanageapi/Shop_modifyShopInfo', param, resParams)
}
export function loginOut(param = {}, resParams) { //退出登录
  return request.post('/edcmanageapi/Shop_loginOut', param, resParams)
}
export function modifyPass(param = {}, resParams) { //退出登录
  return request.post('/edcmanageapi/Shop_modifyPass', param, resParams)
}

// 订单
export function getOrderNumsByStatus(param = {}, resParams) {
  return request.post('/edcmanageapi/Order_orderNumsByStatus', param, resParams)
}
export function getOrderByTable(param = {}, resParams) {
  return request.post('/edcmanageapi/Order_getOrderByTable', param, resParams)
}
export function changeOrderTable(param = {}, resParams) {
  return request.post('/edcmanageapi/Order_changeOrderTable', param, resParams)
}
export function getEasySubOrder(param = {}, resParams) {
  return request.post('/edcmanageapi/Order_easySubOrder', param, resParams)
}
export function subOrder(param = {}, resParams) {
  return request.post('/edcmanageapi/Order_subOrder', param, resParams)
}
export function getStatisticsOrdersByDate(param = {}, resParams) {
  return request.post('/edcmanageapi/Order_statisticsOrdersByDate', param, resParams)
}

// 首页数据
export function getStatisticsOrders(param = {}, resParams) { // 订单统计
  return request.post('/edcmanageapi/Order_statisticsOrders', param, resParams)
}
export function getStatisticsOrdersToday(param = {}, resParams) { // 今日订单统计
  return request.post('/edcmanageapi/Order_statisticsOrdersToday', param, resParams)
}
export function getStatisticsCommentNum(param = {}, resParams) { // 评论数统计
  return request.post('/edcmanageapi/Customer_statisticsCommentNum', param, resParams)
}
export function getMemberStatistic(param = {}, resParams) { // 新增会员数据和全部会员数据
  return request.post('/edcmanageapi/Order_getMemberStatistic', param, resParams)
}
export function getFindTop5Goods(param = {}, resParams) { // 月销售排名商品
  return request.post('/edcmanageapi/Goods_findTop5Goods', param, resParams)
}
export function setTableEmpty(param = {}, resParams) { // 清除餐桌
  return request.post('/edcmanageapi/Shop_setTableEmpty', param, resParams)
}
// 打印机设置
export function getPrintRules(param = {}, resParams) { // 普通打印规则列表
  return request.post('/edcmanageapi/Print_printRules', param, resParams)
}
export function savePrintRule(param = {}, resParams) { // 新增编辑打印规则
  return request.post('/edcmanageapi/Print_savePrintRule', param, resParams)
}
export function delPrintRule(param = {}, resParams) { // 删除打印规则
  return request.post('/edcmanageapi/Print_delPrintRules', param, resParams)
}
export function getCountPrintRules(param = {}, resParams) { // 统计规则数量  分页使用
  return request.post('/edcmanageapi/Print_countPrintRules', param, resParams)
}
export function getPrinterDevices(param = {}, resParams) { // 所有打印机记录
  return request.post('/edcmanageapi/Printer_printerDevices', param, resParams)
}
export function getPrintTempConfig(param = {}, resParams) { // 打印模板编辑
  return request.post('/edcmanageapi/Print_getPrintTempConfig', param, resParams)
}
export function setPrintTempConfig(param = {}, resParams) { // 保存模板编辑
  return request.post('/edcmanageapi/Print_setPrintTempConfig', param, resParams)
}
export function batchSaveLocalPrint(param = {}, resParams) { // 批量上传本地打印机记录
  return request.post('/edcmanageapi/Printer_batchSaveLocalPrint', param, resParams)
}
// 营销管理
export function getFuncList(param = {}, resParams) { // 获取已购的订单List
  return request.post('/edcmanageapi/UserFunc_getFuncList', param, resParams)
}


// 加油站管理
export function gasStations(param = {}, resParams) { // 获取加油站列表
    return request.gasPost('/qrcapi/IndustrySolutions_gasStations', param, resParams, false)
}
export function addOrUpdateGasStation(param = {}, resParams) { // 添加/修改加油站
    return request.gasPost('/qrcapi/IndustrySolutions_addOrUpdateGasStation', param, resParams)
}
export function gasStationsCount(param = {}, resParams) { //加油站数量
    return request.gasPost('/qrcapi/IndustrySolutions_gasStationsCount ', param, resParams, false)
}
export function gasStationInfo(param = {}, resParams) { //单个加油站详情
    return request.gasPost('/qrcapi/IndustrySolutions_gasStationInfo ', param, resParams)
}
export function gasDevices(param = {}, resParams) { //油枪列表
    return request.gasPost('/qrcapi/IndustrySolutions_gasDevices ', param, resParams, false)
}
export function gasGoods(param = {}, resParams) { //油品列表
    return request.gasPost('/qrcapi/IndustrySolutions_gasGoods ', param, resParams)
}
export function addOrUpdateGasDevice(param = {}, resParams) { //更改油枪 添加
    return request.gasPost('/qrcapi/IndustrySolutions_addOrUpdateGasDevice ', param, resParams)
}
export function delGasDevice(param = {}, resParams) { //删除油枪
    return request.gasPost('/qrcapi/IndustrySolutions_delGasDevice ', param, resParams)
}
export function gasPrices(param = {}, resParams) { //油价列表
    return request.gasPost('/qrcapi/IndustrySolutions_gasPrices ', param, resParams)
}
export function addOrUpdateGasPrice(param = {}, resParams) { //添加/更新油价(独立油价) 
    return request.gasPost('/qrcapi/IndustrySolutions_addOrUpdateGasPrice', param, resParams)
}
export function updateGasPriceBatcth(param = {}, resParams) { //更新全部油价 
    return request.gasPost('/qrcapi/IndustrySolutions_updateGasPriceBatcth', param, resParams)
}
export function updateGasStationEnable(param = {}, resParams) { //启动禁用加油站     
    return request.gasPost('/qrcapi/IndustrySolutions_updateGasStationEnable', param, resParams)
}
export function gasOrders(param = {}, resParams) { //订单列表     
    return request.gasPost('/qrcapi/IndustrySolutions_gasOrders', param, resParams)
}
export function gasOrdersCount(param = {}, resParams) { //订单数量     
    return request.gasPost('/qrcapi/IndustrySolutions_gasOrdersCount', param, resParams)
}
export function authorizeViewGZH(param = {}, resParams) { //订单数量     
    return request.gasPost('/miniProgram/MiniAppAuth_authorizeViewGZH', param, resParams)
}
export function getWxOfficialAccount(param = {}, resParams) { //获取公众号信息     
    return request.gasPost('/qrcapi/IndustrySolutions_getWxOfficialAccount', param, resParams, false)
}
export function getCustomMenu(param = {}, resParams) { //获取公众号菜单     
    return request.gasPost('/qrcapi/IndustrySolutions_getCustomMenu', param, resParams)
}
export function updateCustomMenu(param = {}, resParams) { //更新公众号菜单     
    return request.gasPost('/qrcapi/IndustrySolutions_updateCustomMenu', param, resParams)
}
export function getCumulative(param = {}, resParams) { //累计金额、订单数、会员数     
    return request.gasPost('qrcapi/MallOrder_getCumulative', param, resParams)
}
export function getCumulativeByDate(param = {}, resParams) { //每天的累计金额、订单数     
    return request.gasPost('qrcapi/MallOrder_getCumulativeByDate', param, resParams)
}


// WEBPACK FOOTER //
// ./src/components/api/index.js